// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__7vvuV","notes":"Notes_notes__2xf0G"};